import styled from 'styled-components'

import { Collapse } from '@/components/ui/collapse'

// Note: Page's PageWrapper is `flex-direction: column; height: 100%`. Collapse's root has
// `overflow: hidden` (needed for its own max-height animation), which resolves its flex
// automatic min-height to 0 - making it the item the flex algorithm shrinks first whenever
// total page content exceeds that fixed height, clipping it below its own computed height.
// flex-shrink: 0 keeps it at its natural size and lets the page scroll instead.
export const AnalyticsCollapse = styled(Collapse)`
  flex-shrink: 0;
`
